/* marquee  */
(function(factory){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],factory)}else if(typeof exports!=="undefined"){module.exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){$.fn.marquee=function(options){return this.each(function(){var o=$.extend({},$.fn.marquee.defaults,options),$this=$(this),$marqueeWrapper,containerWidth,animationCss,verticalDir,elWidth,loopCount=3,playState="animation-play-state",css3AnimationIsSupported=false,_prefixedEvent=function(element,type,callback){var pfx=["webkit","moz","MS","o",""];for(var p=0;p<pfx.length;p++){if(!pfx[p])type=type.toLowerCase();element.addEventListener(pfx[p]+type,callback,false)}},_objToString=function(obj){var tabjson=[];for(var p in obj){if(obj.hasOwnProperty(p)){tabjson.push(p+":"+obj[p])}}tabjson.push();return"{"+tabjson.join(",")+"}"},_startAnimationWithDelay=function(){$this.timer=setTimeout(animate,o.delayBeforeStart)},methods={pause:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"paused")}else{if($.fn.pause){$marqueeWrapper.pause()}}$this.data("runningStatus","paused");$this.trigger("paused")},resume:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"running")}else{if($.fn.resume){$marqueeWrapper.resume()}}$this.data("runningStatus","resumed");$this.trigger("resumed")},toggle:function(){methods[$this.data("runningStatus")==="resumed"?"pause":"resume"]()},destroy:function(){clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find(".js-marquee:first").html())}};if(typeof options==="string"){if($.isFunction(methods[options])){if(!$marqueeWrapper){$marqueeWrapper=$this.find(".js-marquee-wrapper")}if($this.data("css3AnimationIsSupported")===true){css3AnimationIsSupported=true}methods[options]()}return}var dataAttributes={},attr;$.each(o,function(key){attr=$this.attr("data-"+key);if(typeof attr!=="undefined"){switch(attr){case"true":attr=true;break;case"false":attr=false;break}o[key]=attr}});if(o.speed){o.duration=parseInt($this.width(),10)/o.speed*1e3}verticalDir=o.direction==="up"||o.direction==="down";o.gap=o.duplicated?parseInt(o.gap):0;$this.wrapInner('<div class="js-marquee"></div>');var $el=$this.find(".js-marquee").css({"margin-right":o.gap,float:"left"});if(o.duplicated){$el.clone(true).appendTo($this)}$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper=$this.find(".js-marquee-wrapper");if(verticalDir){var containerHeight=$this.height();$marqueeWrapper.removeAttr("style");$this.height(containerHeight);$this.find(".js-marquee").css({float:"none","margin-bottom":o.gap,"margin-right":0});if(o.duplicated){$this.find(".js-marquee:last").css({"margin-bottom":0})}var elHeight=$this.find(".js-marquee:first").height()+o.gap;if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration;o.duration=parseInt(elHeight,10)/parseInt(containerHeight,10)*o.duration}else{o.duration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration}}else{elWidth=$this.find(".js-marquee:first").width()+o.gap;containerWidth=$this.width();if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration;o.duration=parseInt(elWidth,10)/parseInt(containerWidth,10)*o.duration}else{o.duration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration}}if(o.duplicated){o.duration=o.duration/2}if(o.allowCss3Support){var elm=document.body||document.createElement("div"),animationName="marqueeAnimation-"+Math.floor(Math.random()*1e7),domPrefixes="Webkit Moz O ms Khtml".split(" "),animationString="animation",animationCss3Str="",keyframeString="";if(elm.style.animation!==undefined){keyframeString="@keyframes "+animationName+" ";css3AnimationIsSupported=true}if(css3AnimationIsSupported===false){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+"AnimationName"]!==undefined){var prefix="-"+domPrefixes[i].toLowerCase()+"-";animationString=prefix+animationString;playState=prefix+playState;keyframeString="@"+prefix+"keyframes "+animationName+" ";css3AnimationIsSupported=true;break}}}if(css3AnimationIsSupported){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s infinite "+o.css3easing;$this.data("css3AnimationIsSupported",true)}}var _rePositionVertically=function(){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+elHeight+"px")+")")},_rePositionHorizontally=function(){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+elWidth+"px")+")")};if(o.duplicated){if(verticalDir){if(o.startVisible){$marqueeWrapper.css("transform","translateY(0)")}else{$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+(elHeight*2-o.gap)+"px")+")")}}else{if(o.startVisible){$marqueeWrapper.css("transform","translateX(0)")}else{$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+(elWidth*2-o.gap)+"px")+")")}}if(!o.startVisible){loopCount=1}}else if(o.startVisible){loopCount=2}else{if(verticalDir){_rePositionVertically()}else{_rePositionHorizontally()}}var animate=function(){if(o.duplicated){if(loopCount===1){o._originalDuration=o.duration;if(verticalDir){o.duration=o.direction==="up"?o.duration+containerHeight/(elHeight/o.duration):o.duration*2}else{o.duration=o.direction==="left"?o.duration+containerWidth/(elWidth/o.duration):o.duration*2}if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}loopCount++}else if(loopCount===2){o.duration=o._originalDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}loopCount++}}if(verticalDir){if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?0:"-"+elHeight+"px")+")")}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":containerHeight+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionVertically()}}else{_rePositionVertically();animationCss={transform:"translateY("+(o.direction==="up"?"-"+$marqueeWrapper.height()+"px":containerHeight+"px")+")"}}}else{if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?0:"-"+elWidth+"px")+")")}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionHorizontally()}}else{_rePositionHorizontally();animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"}}}$this.trigger("beforeStarting");if(css3AnimationIsSupported){$marqueeWrapper.css(animationString,animationCss3Str);var keyframeCss=keyframeString+" { 100%  "+_objToString(animationCss)+"}",$styles=$marqueeWrapper.find("style");if($styles.length!==0){$styles.filter(":last").html(keyframeCss)}else{$("head").append("<style>"+keyframeCss+"</style>")}_prefixedEvent($marqueeWrapper[0],"AnimationIteration",function(){$this.trigger("finished")});_prefixedEvent($marqueeWrapper[0],"AnimationEnd",function(){animate();$this.trigger("finished")})}else{$marqueeWrapper.animate(animationCss,o.duration,o.easing,function(){$this.trigger("finished");if(o.pauseOnCycle){_startAnimationWithDelay()}else{animate()}})}$this.data("runningStatus","resumed")};$this.on("pause",methods.pause);$this.on("resume",methods.resume);if(o.pauseOnHover){$this.on("mouseenter",methods.pause);$this.on("mouseleave",methods.resume)}if(css3AnimationIsSupported&&o.allowCss3Support){animate()}else{_startAnimationWithDelay()}})};$.fn.marquee.defaults={allowCss3Support:true,css3easing:"linear",easing:"linear",delayBeforeStart:1e3,direction:"left",duplicated:false,duration:5e3,speed:0,gap:20,pauseOnCycle:false,pauseOnHover:false,startVisible:false}});
function allSiteMarquee() {
  var widthMarquee = $(window).width();
  if(widthMarquee < 750)
  {
    $('.Index_information_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_information_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  
  
}
allSiteMarquee()

$(".Tabs_common_inner_new").click(function() {
    var tab_id = $(this).attr("tab_id");
    if ($(this).hasClass("active") == false) {
        $(this).parents(".Tabs_common_main_new").find(".Tabs_common_inner_new").removeClass("active");
        $(this).parents(".Tabs_common_main_new").find(".tabcontent").css("display", "none");

        $(this).addClass("active");
        $(this).parents(".Tabs_common_main_new").find("." + tab_id + "_open").css("display", "block");
    }
})

function initAccordion() {
    $(".accordion .question").click(function() {
        if ($(this).parent("li").hasClass("open") == false) {
            $(this).parents(".accordion").find(".answer").slideUp();
            $(this).parents(".accordion").find("li").removeClass("open");

            $(this).next(".answer").slideDown();
            $(this).parent(".accordion li").addClass("open");
        } else {
            $(this).parents(".accordion").find(".answer").slideUp();
            //$(this).parents(".accordion").find(".answer").css("display", "none");
            $(this).parents(".accordion").find("li").removeClass("open");
        }
    })
}
initAccordion();

/*$('.footer-block__details-content .list-unstyled a').on('click', function(event) {
    var target = $(this).attr('href');
    var hash = target.substring(target.indexOf('#') + 1);
    if (hash) {
        $('html, body').stop().animate({
            scrollTop: $("#" + hash).offset().top - 200
        }, 500);

        if ($("#" + hash).hasClass("open") == false) {
            setTimeout(function() {
                $("#" + hash + " .question").trigger("click");
            }, 700)
        }
    }
});*/

$(".play_video_on_hover").hover(function(){
  var URL = $(this).find('video').attr("video_url");
  $(this).find('video').attr("src",URL);
  $(this).find('video').trigger('play');
}, function() {
  $(this).find('video').trigger('pause');
})

/* megamenu */
$(".collection_info_links_new").hover(function(){
  var ID = $(this).attr("menu_id");
  if(ID)
  {
    setTimeout(function(){
      $(".megamenu_right_collection_Info_new").css("display","none");
    	$("."+ID+"_display").css("display","block");
    }, 200);
    $(".collection_info_links_new").removeClass("active");
    $(this).addClass("active");
  }
})

function screenHeight() {
  var headerHeight = $(".header-section").outerHeight(true) || 0;
  var section_height = $(window).outerHeight(true) || 0;
  var totalHeight = section_height - headerHeight;
  $(".Index_banner_custom_block_loops_innerblock_new").height("");
  $(".Index_banner_custom_block_loops_innerblock_new").height(totalHeight+"px");

  $(".Index_media_overlay_texts_block_innerstatic_new").height("");
  $(".Index_media_overlay_texts_block_innerstatic_new").height(section_height+"px");

  $(".Product_object_slideshow_loops_innerblock_new").height("");
  $(".Product_object_slideshow_loops_innerblock_new").height(section_height+"px");
}
screenHeight();
$(window).resize(function(){
  screenHeight();
});

function mobileMenuHeight() {
  var headerHeight = $(".header").outerHeight(true) || 56;
  var totalHeight = headerHeight;
  $(".menu-drawer").css("top", totalHeight + "px");
  $(".menu-drawer__backdrop").css("top", totalHeight + "px");
  $(".menu-drawer").css("height", "calc(100% - "+totalHeight+"px)");

  var totalHeightUp = headerHeight - 1;

  $("[data-scroll-direction=up] .menu-drawer").css("top", totalHeightUp + "px");
  $("[data-scroll-direction=up] .menu-drawer__backdrop").css("top", totalHeightUp + "px");
  $("[data-scroll-direction=up] .menu-drawer").css("height", "calc(100% - "+ totalHeightUp +"px)");
}
// Run once DOM is ready
$(document).ready(function () {
  mobileMenuHeight();
});
$(".header__icon--menu").click(function () {
  mobileMenuHeight();
  $('body').addClass("mobile_menu_open_new");
  var headerHeight = $(".header").outerHeight(true) || 56;
  var totalHeight = headerHeight;
  $(".menu-drawer").css("top", totalHeight + "px");
  $(".menu-drawer__backdrop").css("top", totalHeight + "px");
  $(".menu-drawer").css("height", "calc(100% - "+totalHeight+"px)");

  var totalHeightUp = headerHeight - 1;

  $("[data-scroll-direction=up] .menu-drawer").css("top", totalHeightUp + "px");
  $("[data-scroll-direction=up] .menu-drawer__backdrop").css("top", totalHeightUp + "px");
  $("[data-scroll-direction=up] .menu-drawer").css("height", "calc(100% - "+ totalHeightUp +"px)");
});
$(".menu-drawer__close-button").click(function () {
  $('body').removeClass("mobile_menu_open_new");
});

// Recalculate on resize
$(window).on("resize", mobileMenuHeight);

if($(".header").length > 0)
{
  var stickyHeaderTopSticky = 110;
  $(window).scroll(function(){
  
    if( $(window).scrollTop() > stickyHeaderTopSticky ) {
        if($('body').hasClass("sticky_logo_new") == false)
        {
            $('body').addClass("sticky_logo_new");
        }
    } else {
        $('body').removeClass("sticky_logo_new");
    }
  });
}

// $(".play_icon_new").click(function(){
//   if($(this).hasClass("active") == false)
//   {
//     $(this).parents(".video_play_list").find(".play_icon_new").removeClass("active");
//     $(this).parents(".video_play_list").find('video').trigger('pause');
//     $(this).parents(".video_play_list").find(".play_icon").css("display","block");
    
//     $(this).addClass("active");
//     var URL = $(this).find('video').attr("video_url");
//     if($(this).find('video').attr("src") == null)
//     {
//       $(this).find('video').attr("src",URL);
//     }
//     $(this).find('video').trigger('play');
//     $(this).siblings().find('video').trigger('pause');
//     $(this).siblings().find('.play_icon').css("display","block");
//     $(this).find(".play_icon").css("display","none");
//   }
//   else
//   {
//     $(this).removeClass("active");
//     $(this).find('video').trigger('pause');
//     $(this).find(".play_icon").css("display","block");
//   }
// })
// $(".tab_video_pause .tablinks, .accordian_video_pause").click(function() {
//   $(this).parents(".video_play_list").find(".play_icon_new").removeClass("active");
//   $(this).parents(".video_play_list").find(".play_icon").css("display","block");
//   $(this).parents(".video_play_list").find('video').trigger('pause');
// })

document.querySelectorAll(".play_icon_new").forEach(function (playIcon) {
  playIcon.addEventListener("click", function () {
    var video = this.querySelector("video");
    if (!video) return;
    var wasActive = this.classList.contains("active");
    document.querySelectorAll(".video_play_list video").forEach(function (vid) {
      vid.pause();
      vid.removeAttribute("src");
      vid.load();
      var metaPoster = vid.getAttribute("data-meta-poster");
      if (metaPoster) {
        vid.setAttribute("poster", metaPoster);
      }
    });
    document.querySelectorAll(".play_icon_new").forEach(el => el.classList.remove("active"));
    document.querySelectorAll(".play_icon").forEach(icon => icon.style.display = "block");
    if (wasActive) return;
    this.classList.add("active");
    var videoURL = video.getAttribute("video_url");
    if (videoURL) {
      video.setAttribute("src", videoURL);
      video.load();
    }
    video.play();
    this.querySelector(".play_icon").style.display = "none";
  });
});
// 
function stopAllVideos() {
  document.querySelectorAll(".video_play_list video").forEach(function (vid) {
    vid.pause();
    vid.removeAttribute("src");
    vid.load();

    var metaPoster = vid.getAttribute("data-meta-poster");
    if (metaPoster) {
      vid.setAttribute("poster", metaPoster);
    }
  });

  document.querySelectorAll(".play_icon_new").forEach(el => el.classList.remove("active"));
  document.querySelectorAll(".play_icon").forEach(icon => icon.style.display = "block");
}
// AUTO STOP WHEN SECTION SCROLLS OUT OF VIEW
document.addEventListener("DOMContentLoaded", function () {
  const videoSections = document.querySelectorAll(".video_play_list");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        stopAllVideos();
      }
    });
  }, {
    threshold: 0.1 
  });
  videoSections.forEach(section => {
    observer.observe(section);
  });
});

document.querySelectorAll(".Tabs_common_inner_new").forEach(tab => {
  tab.addEventListener("click", stopAllVideos);
});




function productPageScript(){

  /* Size Guide Popup */
  $(".size_guide_new").click(function () {
    $('body').addClass("overflow-hidden");
    $(".overlay_background").addClass("open");
    $(".size_guide_mainpopup_new").fadeIn();
  })
  $(".overlay_background, .size_guide_mainclose_new").click(function () {
    $('body').removeClass("overflow-hidden");
    $(".overlay_background").removeClass("open");
    $(".size_guide_mainpopup_new").fadeOut();
  })

  /* Whats Included Popup */
  $(".Product_whats_included_maintitle_new").click(function () {
    $('body').addClass("overflow-hidden");
    $(".overlay_background").addClass("open");
    $(".Product_whats_included_mainpopup_new").fadeIn();
  })
  $(".overlay_background, .Product_whats_included_mainclose_new").click(function () {
    $('body').removeClass("overflow-hidden");
    $(".overlay_background").removeClass("open");
    $(".Product_whats_included_mainpopup_new").fadeOut();
  })

  /* Sticky */
  if($(".Product_custom_scroll_all_main_top_new").length > 0)
  {
    var headerHeightProduct = $(".Product_custom_scroll_all_main_new").outerHeight(true) || 0;
    $(".Product_custom_scroll_all_main_top_new").css("min-height", headerHeightProduct+"px");

    $(window).scroll(function(){
      var stickyHeaderTopSticky = $(".Product_custom_scroll_all_main_top_new").offset().top;
      if( $(window).scrollTop() > stickyHeaderTopSticky ) {
          if($('body').hasClass("fixed_collection_new") == false)
          {
              $('body').addClass('fixed_collection_new');
          }
      } else {
          $('body').removeClass('fixed_collection_new');
      }
    });
  }
  if($(".product_page_scroll_new").length > 0)
  {
    // Add active class on scroll
    $(window).on("scroll", function() {
        var scrollPosition = $(window).scrollTop();
        $(".product_page_scroll_new").each(function() {
            var width = $(window).width();
            var sectionTop = $(this).offset().top - 70;
            var sectionBottom = sectionTop + $(this).outerHeight();
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                var currentId = $(this).attr("id");
                $(".Product_custom_scroll_all_loops_new a").removeClass("active");
                $(".Product_custom_scroll_all_loops_new a[href='#" + currentId + "']").addClass("active");
            }
        });
    });
  }

  /* Features Popup */
  // $(".Product_object_features_block_innerloops_mainblock_new").click(function () {
  //   var width = $(window).width();
  //   if(width >= 750){}
  //     $('body').addClass("overflow-hidden");
  //     $(".overlay_background").addClass("open");
  //     $(".Product_object_features_block_mainpopup_new").fadeIn();
  // })
  // $(".overlay_background, .Product_object_features_block_mainclose_new").click(function () {
  //   $('body').removeClass("overflow-hidden");
  //   $(".overlay_background").removeClass("open");
  //   $(".Product_object_features_block_mainpopup_new").fadeOut();
  // })

  // $(".Product_meta_video_block_innerloops_mainmedia_new").click(function () {
  //   var width = $(window).width();
  //   if(width >= 750){}
  //     $('body').addClass("overflow-hidden");
  //     $(".overlay_background").addClass("open");
  //     var video_html = $(this).find('video').clone();
  //     $(".Product_meta_video_new_block_mainpopup_new .Product_meta_video_new_popup").html(video_html);
  //     $(".Product_meta_video_new_block_mainpopup_new").fadeIn();
  //     var URL = $(".Product_meta_video_new_block_mainpopup_new .Product_meta_video_new_popup video").attr("video_url");
  //     $(".Product_meta_video_new_block_mainpopup_new .Product_meta_video_new_popup video").attr("src",URL);
  //     $(".Product_meta_video_new_block_mainpopup_new .Product_meta_video_new_popup video").attr("loop",true);
  //     $(".Product_meta_video_new_block_mainpopup_new .Product_meta_video_new_popup video")[0].play();
  // });
  $(".Product_meta_video_block_innerloops_mainmedia_new")
  .on("click touchstart", function (e) {
    e.preventDefault();

    // console.log('event works');

    $('body').addClass("overflow-hidden");
    $(".overlay_background").addClass("open");

    var video_html = $(this).find('video').clone();
    $(".Product_meta_video_new_block_mainpopup_new .Product_meta_video_new_popup")
      .html(video_html);

    $(".Product_meta_video_new_block_mainpopup_new").fadeIn();

    var video = $(".Product_meta_video_new_popup video")[0];
    var URL = $(video).attr("video_url");

    video.src = URL;
    video.loop = true;
    video.muted = true; 
    video.play();
});
  $(".overlay_background, .Product_meta_video_new_block_mainclose_new").click(function () {
    $('body').removeClass("overflow-hidden");
    $(".overlay_background").removeClass("open");
    $(".Product_meta_video_new_block_mainpopup_new").fadeOut();
    $(".Product_meta_video_new_block_mainpopup_new .Product_meta_video_new_popup").html('');
  });

  /* Specification Tab */
  $(".Product_object_tab_detail_block_innerblock_innerloops_mainboxs_mainaccordion_new").click(function() {
    if ($(this).hasClass("active") == false) {
        $(this).parents(".Product_object_tab_detail_block_innerblock_innerloops_new").find(".Product_object_tab_detail_block_innerblock_innerloops_innerboxs_new").slideUp();
        $(this).parents(".Product_object_tab_detail_block_innerblock_innerloops_new").find(".Product_object_tab_detail_block_innerblock_innerloops_mainboxs_mainaccordion_new").removeClass("active");

        $(this).next(".Product_object_tab_detail_block_innerblock_innerloops_innerboxs_new").slideDown();
        $(this).addClass("active");
    } else {
        $(this).parents(".Product_object_tab_detail_block_innerblock_innerloops_new").find(".Product_object_tab_detail_block_innerblock_innerloops_innerboxs_new").slideUp();
        $(this).parents(".Product_object_tab_detail_block_innerblock_innerloops_new").find(".Product_object_tab_detail_block_innerblock_innerloops_mainboxs_mainaccordion_new").removeClass("active");
    }
  })

  /* Gallery */
  $(".view_more_product").click(function() {
    var product_id = $(this).attr("product_id");
    $("."+product_id+" .hide_this_product_desktop").addClass("open");
    $("."+product_id+" .hide_this_product_mobile").addClass("open");
    $("."+product_id+" .view_more_product").css("display","none");
  })
  Fancybox.bind("[data-fancybox]", {
    /*Carousel: {
      Video: {
        autoplay: false,
      },
    },*/
    Carousel: {
      Thumbs: false,
    },
  });

  /* Review */
  function hideEmptyCustomForms() {
    document.querySelectorAll(".jdgm-rev__custom-form").forEach(el => {
      if (el.textContent.trim() === "" && el.children.length === 0) {
        el.style.display = "none";
      } else {
        el.style.display = ""; // restore if content gets added
      }
    });
  }
  // Run once on page load
  hideEmptyCustomForms();
  // Watch for future changes
  const observer = new MutationObserver(() => hideEmptyCustomForms());
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  /* Sticky ATC */
  if($(".Product_information_new").length > 0)
  {
    $(window).scroll(function(){
      $(".variant-picker").css("min-height", 0+"px");
      var variantpicker = $(".variant-picker__form").outerHeight(true) || 0;
      $(".variant-picker").css("min-height", variantpicker+"px");
      
      var stickyHeaderTopSticky_variantpicker = $(".Product_information_new").outerHeight(true) || 0;
      if( $(window).scrollTop() > stickyHeaderTopSticky_variantpicker ) {
          if($('body').hasClass("fixed_addtocart_new") == false)
          {
              $('body').addClass('fixed_addtocart_new');
          }
      } else {
          $('body').removeClass('fixed_addtocart_new');
      }
    });
  }

  $(".fixed_product_atc_button_new").click(function() {
    $(".add-to-cart-button").trigger("click");
  })

  $(".fixed_product_option_top_option_new").click(function() {
    $('body').addClass("open_variant");
  })

  $(".mobile_variant_close_new, .open_variant").click(function() {
    $('body').removeClass("overflow-hidden");
    $('body').removeClass("open_variant");
  })

  document.querySelectorAll('.Product_custom_scroll_all_loops_mainblock_new a[href^="#"]').forEach(link => {
    link.addEventListener("click", function(e) {
      e.preventDefault();

      const targetId = this.getAttribute("href").substring(1);
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        const offset = 20; // 👈 your stop-before value
        const elementPosition = targetEl.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  });

}
productPageScript()
document.addEventListener('product-size-chart:init', productPageScript)

function collectionListPageScript() {
  /* Sticky for both sections */
  var $targets = $(".Collection_scrolling_list_main_new, .show_collection_top_menu_new");
  if ($targets.length > 0) {
    // Store initial offset once
    var stickyTop = Math.min.apply(Math, $targets.map(function() {
      return $(this).offset().top;
    }).get());

    // Set min-heights once
    $targets.each(function() {
      var h = $(this).outerHeight(true) || 0;
      $(this).css("min-height", h + "px");
    });

    // Track state to avoid repeated class toggles
    var isFixed = false;

    $(window).on("scroll", function() {
      var scrollTop = $(window).scrollTop();

      if (scrollTop > stickyTop && !isFixed) {
        $("body").addClass("fixed_collection_list_new");
        isFixed = true;
      } else if (scrollTop <= stickyTop && isFixed) {
        $("body").removeClass("fixed_collection_list_new");
        isFixed = false;
      }
    });
  }

  /* Active link on scroll (same as before) */
  if ($(".Collection_lists_template_main_new").length > 0) {
    $(window).on("scroll", function() {
      var scrollPosition = $(window).scrollTop();

      $(".Collection_lists_template_main_new").each(function() {
        var sectionTop = $(this).offset().top - 70;
        var sectionBottom = sectionTop + $(this).outerHeight();

        if (scrollPosition < 100) {
          $(".Collection_scrolling_list_loops_innerboxs_new a").removeClass("active");
          $(".Collection_scrolling_list_loops_innerboxs_new a.Collection_scrolling_list_first_new").addClass("active");
        } else if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          var currentId = $(this).attr("id");
          $(".Collection_scrolling_list_loops_innerboxs_new a").removeClass("active");
          $(".Collection_scrolling_list_loops_innerboxs_new a[href='#" + currentId + "']").addClass("active");
        }
      });
    });
  }
}

collectionListPageScript();

/* Index_banner_custom_block_slider */
new Swiper('.Index_banner_custom_block_slider', {
    loop: true,
    grabCursor: true,
    spaceBetween: 0,
    slidesPerGroup: 1,
    slidesPerView: 1,
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    pagination: {
        el: ".swiper-pagination",
        type: "fraction",
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' +
                ' / ' +
                '<span class="' + totalClass + '"></span>';
        },
        formatFractionCurrent: function (number) {
          return number < 10 ? '0' + number : number;
        },
        formatFractionTotal: function (number) {
          return number < 10 ? '0' + number : number;
        }
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    scrollbar: {
        el: ".swiper-scrollbar",
    },
    observer: true,
    observeParents: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    }
})


/* Index_collections_list_slider */
new Swiper('.Index_collections_list_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 12,
      freeMode: !1,
      grid: {
        rows: 2,
      },
    },
    750: {
      spaceBetween: 16,
      grid: {
        rows: 1,
      },
    },
    990: {
      spaceBetween: 24
    },
    1200: {
    },
    1440: {
    }
  }
})


/* Index_custom_feature_item_slider */
new Swiper('.Index_custom_feature_item_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 10,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})


/* Index_featured_items_list_desktop_slider */
new Swiper('.Index_featured_items_list_desktop_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 12,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  direction: 'vertical'
})


/* Index_featured_items_list_mobile_slider */
new Swiper('.Index_featured_items_list_mobile_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 12,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})


/* Product_object_slideshow_slider */
new Swiper('.Product_object_slideshow_slider', {
    loop: true,
    grabCursor: true,
    spaceBetween: 0,
    slidesPerGroup: 1,
    slidesPerView: 1,
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    pagination: {
        el: ".swiper-pagination",
        type: "fraction",
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' +
                ' / ' +
                '<span class="' + totalClass + '"></span>';
        },
        formatFractionCurrent: function (number) {
          return number < 10 ? '0' + number : number;
        },
        formatFractionTotal: function (number) {
          return number < 10 ? '0' + number : number;
        }
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    scrollbar: {
        el: ".swiper-scrollbar",
    },
    observer: true,
    observeParents: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    /*autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    }*/
})


/* Product_custom_scroll_all_slider */
new Swiper('.Product_custom_scroll_all_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 16,
      freeMode: !1
    },
    750: {
      spaceBetween: 24
    },
    990: {
    },
    1200: {
    },
    1440: {
    }
  }
})


/* Product_object_features_slider */
const mainSwiper = new Swiper('.Product_object_features_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: true,
  autoHeight: false,
  watchOverflow: true,
  threshold: 10,
  mousewheel: {
    forceToAxis: true
  },
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
    renderFraction: function (currentClass, totalClass) {
      return (
        '<span class="' + currentClass + '"></span>' +
        ' / ' +
        '<span class="' + totalClass + '"></span>'
      );
    },
    formatFractionCurrent: number => (number < 10 ? '0' + number : number),
    formatFractionTotal: number => (number < 10 ? '0' + number : number)
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  observer: true,
  observeParents: true,
  breakpoints: {
    0: { spaceBetween: 12 },
    750: { spaceBetween: 16 }
  }
});
/* popup featured slider */
const popupSwiper = new Swiper('.Product_object_features_popup_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 10,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable: true,
  autoHeight: false,
  watchOverflow: true,
  threshold: 10,
  mousewheel: {
    forceToAxis: true
  },
  pagination: {
    el: ".Product_object_features_block_mainpopup_new .swiper-pagination"
  },
  observer: true,
  observeParents: true
});
let scrollPosition = 0;
$(document).on('click', '.Product_object_features_slider .swiper-slide', function () {
  const realIndex = $(this).attr('data-swiper-slide-index');
  const slideIndex = parseInt(realIndex, 10) || 0;
  scrollPosition = $(window).scrollTop();
  $('body').addClass('popup-open').css({
    top: -scrollPosition + 'px',
  });
  $('.overlay_background').addClass('open');
  $('.Product_object_features_block_mainpopup_new').fadeIn();
  popupSwiper.slideTo(slideIndex, 0);
});
$(document).on('click', '.overlay_background, .Product_object_features_block_mainclose_new', function () {
  $('.Product_object_features_block_mainpopup_new').fadeOut();
  $('.overlay_background').removeClass('open');
  $('body').removeClass('popup-open').css({ top: '' });
  $(window).scrollTop(scrollPosition);
});
// const mainSwiper = new Swiper('.Product_object_features_slider', {
//   loop: true,
//   grabCursor: false,
//   spaceBetween: 16,
//   slidesPerGroup: 1,
//   slidesPerView: "auto",
//   watchSlidesProgress: true,
//   draggable: !0,
//   autoHeight: !1,
//   watchOverflow: !0,
//   threshold: 10,
//   mousewheel: {
//       forceToAxis: !0
//   },
//   pagination: {
//       el: ".swiper-pagination",
//       type: "fraction",
//       renderFraction: function (currentClass, totalClass) {
//         return '<span class="' + currentClass + '"></span>' +
//               ' / ' +
//               '<span class="' + totalClass + '"></span>';
//       },
//       formatFractionCurrent: function (number) {
//         return number < 10 ? '0' + number : number;
//       },
//       formatFractionTotal: function (number) {
//         return number < 10 ? '0' + number : number;
//       }
//   },
//   navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//   },
//   scrollbar: {
//       el: ".swiper-scrollbar",
//   },
//   observer: true,
//   observeParents: true,
//   breakpoints: {
//     0: {
//       spaceBetween: 12
//     },
//     750: {
//       spaceBetween: 16
//     },
//     990: {
//     },
//     1200: {
//     },
//     1440: {
//     }
//   }
// })
// /* Product_object_features_popup_slider */
// const popupSwiper = new Swiper('.Product_object_features_popup_slider', {
//   loop: false,
//   grabCursor: true,
//   spaceBetween: 10,
//   slidesPerGroup: 1,
//   slidesPerView: 1,
//   watchSlidesProgress: true,
//   draggable: !0,
//   autoHeight: !1,
//   watchOverflow: !0,
//   threshold: 10,
//   mousewheel: {
//       forceToAxis: !0
//   },
//   pagination: {
//       el: ".swiper-pagination"
//   },
//   observer: true,
//   observeParents: true
// })
// $('.Product_object_features_slider .swiper-slide').on('click', function () {
//   var index = $(this).index(); // get clicked slide index
//   popupSwiper.slideTo(index, 0); // jump to that slide
// });


/* Product_meta_video_slider */
var Product_meta_video_slider = new Swiper('.Product_meta_video_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 25,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' +
              ' / ' +
              '<span class="' + totalClass + '"></span>';
      },
      formatFractionCurrent: function (number) {
        return number < 10 ? '0' + number : number;
      },
      formatFractionTotal: function (number) {
        return number < 10 ? '0' + number : number;
      }
  },  
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  scrollbar: {
      el: ".swiper-scrollbar",
  },  
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 8
    },
    750: {
      spaceBetween: 25
    },
    990: {
    },
    1200: {
    },
    1440: {
    }
  }
})
Product_meta_video_slider.on("slideChange", function () {
  // Pause all videos inside this swiper using jQuery
  $(Product_meta_video_slider.el).find("video").each(function () {
    this.pause();
    $(this).parents(".video_play_list").find(".play_icon_new").removeClass("active");
    $(this).parents(".video_play_list").find(".play_icon").css("display","block");
  });
});

$(document).on("click", ".Product_meta_video_slider .swiper-slide", function () {
  const index = $(this).index();
  Product_meta_video_slider.slideTo(index);
});

/* Collection_scrolling_list_slider */
new Swiper('.Collection_scrolling_list_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 12,
      freeMode: !1
    },
    750: {
      spaceBetween: 16,
    },
    990: {
      spaceBetween: 24,
    },
    1200: {
    },
    1440: {
    }
  }
})


/* Collection_icon_with_text_slider */
new Swiper('.Collection_icon_with_text_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 36,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 16,
      freeMode: !1
    },
    750: {
      spaceBetween: 24
    },
    990: {
      spaceBetween: 36
    },
    1200: {
    },
    1440: {
    }
  }
})


/* Collection_lists_template_slider */
new Swiper('.Collection_lists_template_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: 4,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 12,
      slidesPerView: "auto",
      freeMode: !1
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 16
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 24
    },
    1440: {
    }
  }
})

/* Collection_lists_template_slider_3 */
new Swiper('.Collection_lists_template_slider_3', {
  loop: false,
  grabCursor: true,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: 3,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 12,
      slidesPerView: "auto",
      freeMode: !1
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 16
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 24
    },
    1200: {
    },
    1440: {
    }
  }
})

/* Collection_menu_list_slider */
new Swiper('.Collection_menu_list_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 12,
      freeMode: !1
    },
    750: {
      spaceBetween: 16,
    },
    990: {
      spaceBetween: 24,
    },
    1200: {
    },
    1440: {
    }
  }
})

/* Collection_submenu_list_slider */
new Swiper('.Collection_submenu_list_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 16,
      freeMode: !1
    },
    750: {
      spaceBetween: 16,
    },
    990: {
      spaceBetween: 24,
    },
    1200: {
    },
    1440: {
    }
  }
})

/* Collection_submenu_mobile_list_slider */
new Swiper('.Collection_submenu_mobile_list_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 8,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
})


// Number Fields Validate
document.querySelectorAll('input[type="number"]').forEach(function(numberInput){
  numberInput.addEventListener('keypress', function (e) {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault(); // Prevent typing non-numbers
    }
  });
});

/*!
* Optiscroll.js 
*/
!function(E,y,C,o){"use strict";var i=function t(e,i){return new t.Instance(e,i||{})},c=i.globalSettings={scrollMinUpdateInterval:25,checkFrequency:1e3,pauseCheck:!1};i.defaults={preventParentScroll:!1,forceScrollbars:!1,scrollStopDelay:300,maxTrackSize:95,minTrackSize:5,draggableTracks:!0,autoUpdate:!0,classPrefix:"optiscroll-",wrapContent:!0,rtl:!1},(i.Instance=function(t,e){this.element=t,this.settings=S(S({},i.defaults),e||{}),"boolean"!=typeof e.rtl&&(this.settings.rtl="rtl"===E.getComputedStyle(t).direction),this.cache={},this.init()}).prototype={init:function(){var t=this.element,e=this.settings,i=!1,l=this.scrollEl=e.wrapContent?u.createWrapper(t):t.firstElementChild;T(l,e.classPrefix+"content",!0),T(t,"is-enabled"+(e.rtl?" is-rtl":""),!0),this.scrollbars={v:s("v",this),h:s("h",this)},(w.scrollbarSpec.width||e.forceScrollbars)&&(i=u.hideNativeScrollbars(l,e.rtl)),i&&h(this.scrollbars,"create"),w.isTouch&&e.preventParentScroll&&T(t,e.classPrefix+"prevent",!0),this.update(),this.bind(),e.autoUpdate&&w.instances.push(this),e.autoUpdate&&!w.checkTimer&&u.checkLoop()},bind:function(){var l,s,n,r,t=this.listeners={},e=this.scrollEl;for(var i in t.scroll=(l=a.scroll.bind(this),s=c.scrollMinUpdateInterval,function(){var t=this,e=Date.now(),i=arguments;n&&e<n+s?(clearTimeout(r),r=setTimeout(function(){n=e,l.apply(t,i)},s)):(n=e,l.apply(t,i))}),w.isTouch&&(t.touchstart=a.touchstart.bind(this),t.touchend=a.touchend.bind(this)),t.mousewheel=t.wheel=a.wheel.bind(this),t)e.addEventListener(i,t[i],w.passiveEvent)},update:function(){var t=this.scrollEl,e=this.cache,i=e.clientH,l=t.scrollHeight,s=t.clientHeight,n=t.scrollWidth,r=t.clientWidth;if(l!==e.scrollH||s!==e.clientH||n!==e.scrollW||r!==e.clientW){if(e.scrollH=l,e.clientH=s,e.scrollW=n,e.clientW=r,i!==o){if(0===l&&0===s&&!y.body.contains(this.element))return this.destroy(),!1;this.fireCustomEvent("sizechange")}h(this.scrollbars,"update")}},scrollTo:function(t,e,i){var l,s,n,r,o=this.cache;w.pauseCheck=!0,this.update(),l=this.scrollEl.scrollLeft,s=this.scrollEl.scrollTop,n=+t,"left"===t&&(n=0),"right"===t&&(n=o.scrollW-o.clientW),!1===t&&(n=l),r=+e,"top"===e&&(r=0),"bottom"===e&&(r=o.scrollH-o.clientH),!1===e&&(r=s),this.animateScroll(l,n,s,r,+i)},scrollIntoView:function(t,e,i){var l,s,n,r,o,c,a,h,u,p,d,f,v=this.scrollEl;w.pauseCheck=!0,this.update(),"string"==typeof t?t=v.querySelector(t):t.length&&t.jquery&&(t=t[0]),"number"==typeof i&&(i={top:i,right:i,bottom:i,left:i}),i=i||{},l=t.getBoundingClientRect(),s=v.getBoundingClientRect(),u=d=v.scrollLeft,p=f=v.scrollTop,a=u+l.left-s.left,h=p+l.top-s.top,n=a-(i.left||0),r=h-(i.top||0),n<u&&(d=n),u<(o=a+l.width-this.cache.clientW+(i.right||0))&&(d=o),r<p&&(f=r),p<(c=h+l.height-this.cache.clientH+(i.bottom||0))&&(f=c),this.animateScroll(u,d,p,f,+e)},animateScroll:function(l,s,n,r,o){var c=this,a=this.scrollEl,h=Date.now();if(s!==l||r!==n){if(0===o)return a.scrollLeft=s,void(a.scrollTop=r);isNaN(o)&&(o=15*C.pow(C.max(C.abs(s-l),C.abs(r-n)),.54)),function t(){var e=C.min(1,(Date.now()-h)/o),i=u.easingFunction(e);r!==n&&(a.scrollTop=~~(i*(r-n))+n),s!==l&&(a.scrollLeft=~~(i*(s-l))+l),c.scrollAnimation=e<1?E.requestAnimationFrame(t):null}()}},destroy:function(){var t,e=this,i=this.element,l=this.scrollEl,s=this.listeners;if(this.scrollEl){for(var n in s)l.removeEventListener(n,s[n]);if(h(this.scrollbars,"remove"),!this.settings.contentElement){for(;t=l.childNodes[0];)i.insertBefore(t,l);i.removeChild(l),this.scrollEl=null}T(i,this.settings.classPrefix+"prevent",!1),T(i,"is-enabled",!1),E.requestAnimationFrame(function(){var t=w.instances.indexOf(e);-1<t&&w.instances.splice(t,1)})}},fireCustomEvent:function(t){var e,i,l=this.cache,s=l.scrollH,n=l.scrollW;e={scrollbarV:S({},l.v),scrollbarH:S({},l.h),scrollTop:l.v.position*s,scrollLeft:l.h.position*n,scrollBottom:(1-l.v.position-l.v.size)*s,scrollRight:(1-l.h.position-l.h.size)*n,scrollWidth:n,scrollHeight:s,clientWidth:l.clientW,clientHeight:l.clientH},"function"==typeof CustomEvent?i=new CustomEvent(t,{detail:e}):(i=y.createEvent("CustomEvent")).initCustomEvent(t,!1,!1,e),this.element.dispatchEvent(i)}};var t,e,a={scroll:function(t){w.pauseCheck||this.fireCustomEvent("scrollstart"),w.pauseCheck=!0,this.scrollbars.v.update(),this.scrollbars.h.update(),this.fireCustomEvent("scroll"),clearTimeout(this.cache.timerStop),this.cache.timerStop=setTimeout(a.scrollStop.bind(this),this.settings.scrollStopDelay)},touchstart:function(t){w.pauseCheck=!1,this.scrollbars.v.update(),this.scrollbars.h.update(),a.wheel.call(this,t)},touchend:function(t){clearTimeout(this.cache.timerStop)},scrollStop:function(){this.fireCustomEvent("scrollstop"),w.pauseCheck=!1},wheel:function(t){var e=this.cache,i=e.v,l=e.h,s=this.settings.preventParentScroll&&w.isTouch;E.cancelAnimationFrame(this.scrollAnimation),s&&i.enabled&&i.percent%100==0&&(this.scrollEl.scrollTop=i.percent?e.scrollH-e.clientH-1:1),s&&l.enabled&&l.percent%100==0&&(this.scrollEl.scrollLeft=l.percent?e.scrollW-e.clientW-1:1)}},s=function(e,i){var r="v"===e,l=i.element,o=i.scrollEl,c=i.settings,a=i.cache,n=a[e]={},t=r?"H":"W",h="client"+t,u="scroll"+t,p=r?"scrollTop":"scrollLeft",s=r?["top","bottom"]:["left","right"],d=/^(mouse|touch|pointer)/,f=w.scrollbarSpec.rtl,v=!1,m=null,g=null,b={dragData:null,dragStart:function(t){t.preventDefault();var e=t.touches?t.touches[0]:t;b.dragData={x:e.pageX,y:e.pageY,scroll:o[p]},b.bind(!0,t.type.match(d)[1])},dragMove:function(t){var e,i=t.touches?t.touches[0]:t,l=c.rtl&&1===f&&!r?-1:1;t.preventDefault(),e=(r?i.pageY-b.dragData.y:i.pageX-b.dragData.x)/a[h],o[p]=b.dragData.scroll+e*a[u]*l},dragEnd:function(t){b.dragData=null,b.bind(!1,t.type.match(d)[1])},bind:function(t,e){var i=(t?"add":"remove")+"EventListener",l=e+"move",s=e+("touch"===e?"end":"up");y[i](l,b.dragMove),y[i](s,b.dragEnd),y[i](e+"cancel",b.dragEnd)}};return{toggle:function(t){v=t,g&&T(l,"has-"+e+"track",v),n.enabled=v},create:function(){(m=y.createElement("div"),g=y.createElement("b"),m.className=c.classPrefix+e,g.className=c.classPrefix+e+"track",m.appendChild(g),l.appendChild(m),c.draggableTracks)&&(E.PointerEvent?["pointerdown"]:["touchstart","mousedown"]).forEach(function(t){g.addEventListener(t,b.dragStart)})},update:function(){var t,e,i,l,s;(v||a[h]!==a[u])&&(t=(i=this.calc()).size,e=n.size,l=1/t*i.position*100,s=C.abs(i.position-(n.position||0))*a[h],1===t&&v&&this.toggle(!1),t<1&&!v&&this.toggle(!0),g&&v&&this.style(l,s,t,e),n=S(n,i),v&&this.fireEdgeEv())},style:function(t,e,i,l){i!==l&&(g.style[r?"height":"width"]=100*i+"%",c.rtl&&!r&&(g.style.marginRight=100*(1-i)+"%")),g.style[w.cssTransform]="translate("+(r?"0%,"+t+"%":t+"%,0%")+")"},calc:function(){var t,e=o[p],i=a[h],l=a[u],s=i/l,n=l-i;return 1<=s||!l?{position:0,size:1,percent:0}:(!r&&c.rtl&&f&&(e=n-e*f),t=100*e/n,e<=1&&(t=0),n-1<=e&&(t=100),s=C.max(s,c.minTrackSize/100),{position:t/100*(1-(s=C.min(s,c.maxTrackSize/100))),size:s,percent:t})},fireEdgeEv:function(){var t=n.percent;n.was!==t&&t%100==0&&(i.fireCustomEvent("scrollreachedge"),i.fireCustomEvent("scrollreach"+s[t/100])),n.was=t},remove:function(){this.toggle(!1),m&&(m.parentNode.removeChild(m),m=null)}}},u={hideNativeScrollbars:function(t,e){var i=w.scrollbarSpec.width,l=t.style;if(0===i){var s=Date.now();return t.setAttribute("data-scroll",s),u.addCssRule('[data-scroll="'+s+'"]::-webkit-scrollbar',"display:none;width:0;height:0;")}return l[e?"left":"right"]=-i+"px",l.bottom=-i+"px",!0},addCssRule:function(t,e){var i=y.getElementById("scroll-sheet");i||((i=y.createElement("style")).id="scroll-sheet",i.appendChild(y.createTextNode("")),y.head.appendChild(i));try{return i.sheet.insertRule(t+" {"+e+"}",0),!0}catch(t){return}},createWrapper:function(t,e){for(var i,l=y.createElement("div");i=t.childNodes[0];)l.appendChild(i);return t.appendChild(l)},checkLoop:function(){w.instances.length?(w.pauseCheck||h(w.instances,"update"),c.checkFrequency&&(w.checkTimer=setTimeout(function(){u.checkLoop()},c.checkFrequency))):w.checkTimer=null},easingFunction:function(t){return--t*t*t+1}},w=i.G={isTouch:"ontouchstart"in E,cssTransition:l("transition"),cssTransform:l("transform"),scrollbarSpec:function(){var t,e,i=y.documentElement,l=0,s=1;(t=y.createElement("div")).style.cssText="overflow:scroll;width:50px;height:50px;position:absolute;left:-100px;direction:rtl",(e=y.createElement("div")).style.cssText="width:100px;height:100px",t.appendChild(e),i.appendChild(t),l=t.offsetWidth-t.clientWidth,0<t.scrollLeft?s=0:(t.scrollLeft=1,0===t.scrollLeft&&(s=-1));return i.removeChild(t),{width:l,rtl:s}}(),passiveEvent:(t=!1,e=Object.defineProperty({},"passive",{get:function(){t=!0}}),E.addEventListener("test",null,e),!!t&&{capture:!1,passive:!0}),instances:[],checkTimer:null,pauseCheck:!1};function l(t){var e=t.charAt(0).toUpperCase()+t.slice(1),i=y.createElement("test"),l=[t,"Webkit"+e];for(var s in l)if(i.style[l[s]]!==o)return l[s];return""}function T(t,e,i){var l=t.className.split(/\s+/),s=l.indexOf(e);i?~s||l.push(e):~s&&l.splice(s,1),t.className=l.join(" ")}function S(t,e,i){for(var l in e)!e.hasOwnProperty(l)||t[l]!==o&&i||(t[l]=e[l]);return t}function h(t,e,i){var l,s;if(t.length)for(l=0,s=t.length;l<s;l++)t[l][e].apply(t[l],i);else for(l in t)t[l][e].apply(t[l],i)}"function"==typeof define&&define.amd&&define(function(){return i}),"undefined"!=typeof module&&module.exports&&(module.exports=i),E.Optiscroll=i}(window,document,Math),function(n){var r="optiscroll";n.fn[r]=function(i){var l,s;return"string"==typeof i&&(s=Array.prototype.slice.call(arguments),l=s.shift()),this.each(function(){var t=n(this),e=t.data(r);e?e&&"string"==typeof l&&(e[l].apply(e,s),"destroy"===l&&t.removeData(r)):(e=new window.Optiscroll(this,i||{}),t.data(r,e))})}}(jQuery||Zepto);
function optiscrollInit(){
  $(".optiscroll").removeData('optiscroll')
  $(".optiscroll").optiscroll({ forceScrollbars: true })
}
optiscrollInit();
document.addEventListener('optiscroll:init', optiscrollInit)

// img_with_text_slider
if(document.querySelector('.img_with_text_slider')){
  new Swiper('.img_with_text_slider', {
    slidesPerView: "auto",
    spaceBetween: 27,
    freeMode: false,
    scrollbar: {
        el: ".swiper-scrollbar",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    mousewheel: true,
    breakpoints: {
      750: {
        spaceBetween: 30,
        direction: "vertical"
      }
    }
  });
}

// CWI CODE J
if (document.querySelector('.our_team .our_team_slider')) {
  new Swiper('.our_team .our_team_slider', {
    slidesPerView: "auto",
    spaceBetween: 0,
    breakpoints: {
      0: { 
        enabled: true,
        spaceBetween: 12,
      },      
      990: {
        enabled: false,
        spaceBetween: 0,
      }
    }
  });
}

$(document).on("click",".Product_object_features_block_mainclose_new",function() {
  $(this).closest('.quick-add__popup').removeClass('active');
});


// $(document).on("click",".product_recommendations_product_list_new .Product_card_main_new .product-card__content",function(event) {  
//   event.preventDefault();
  
  // $(this).find('.product_addtocart_button_left_new button').trigger( "click" );
  // $( ".product_recommendations_product_list_new .Product_card_main_new .product_addtocart_button_left_new" ).trigger( "click" );
// });

// $(document).on('click', '.product_recommendations_product_list_new product-card a[ref="productTitleLink"], .product_recommendations_product_list_new product-card a[ref="cardGalleryLink"]', function(e){
//     e.preventDefault();
//     $(this).parents('product-card').find('button[js-quick-add-btn]').click();
// });

$(document).on('click', 'product-card.open_quick_view a[ref="productTitleLink"], product-card.open_quick_view a[ref="cardGalleryLink"], product-card.open_quick_view [ref="priceContainer"]', function(e){
    e.preventDefault();
    $(this).parents('product-card.open_quick_view').find('button[js-quick-add-btn]').click();
});

// CWI CODE N
$(document).on('click', '.product-information zoom-dialog .zoom_popup_arrows', function(e){
  if($(this).hasClass('previous_slide_arrow')){
    $(this).parents(".dialog-thumbnails-list-container").find('button.button[aria-selected="true"]').prev('button').click();
  }else if($(this).hasClass('next_slide_arrow')){
    $(this).parents(".dialog-thumbnails-list-container").find('button.button[aria-selected="true"]').next('button').click();
  }
  window.globalFunction.check_zoom_slide_available();
});

window.globalFunction = {
  check_zoom_slide_available(){
    var previous_button = $('zoom-dialog dialog[open] button.button[aria-selected="true"]').prev('button'),
        next_button = $('zoom-dialog dialog[open] button.button[aria-selected="true"]').next('button');
    $('zoom-dialog dialog[open] .dialog-thumbnails-list button[aria-selected="true"]')[0]
  ?.scrollIntoView({ behavior: 'smooth', block: 'center',
  inline: 'center' });
    if(previous_button.length){
      $('.previous_slide_arrow').removeClass('custom_disabled');
    }else{
      $('.previous_slide_arrow').addClass('custom_disabled');
    }
    if(next_button.length){
      $('.next_slide_arrow').removeClass('custom_disabled');
    }else{
      $('.next_slide_arrow').addClass('custom_disabled');
    }
  }
};

window.addEventListener('videowiseProductAddToCart', function (event) {
  const { variantId, qty } = event.detail || {};
  if (!variantId || !qty) return;

  const sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el.dataset.sectionId) {
      sectionIds.push(el.dataset.sectionId);
    }
  });

  fetch('/?sections=' + sectionIds.join(','))
    .then((res) => res.json())
    .then((sections) => {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: null,
            sourceId: 'videowise',
            data: {
              source: 'videowise',
              itemCount: qty,
              variantId: String(variantId),
              sections: sections,
            },
          },
        })
      );
      document.querySelector('cart-drawer-component')?.open();
    })
    .catch(console.error);
});

document.addEventListener("DOMContentLoaded", function () {

  const forms = document.querySelectorAll('[js-gearmetter-form]');
  const blogItems = document.querySelectorAll('.hb_gearmatters__blog-item');
  const noResult = document.querySelector('.hb_gearmatters__empty');

  if (!forms.length || !blogItems.length || !noResult) {
    console.warn("Form, blog-items, or empty div missing.");
    return;
  }

  function filterCards(searchTerm) {
    const term = searchTerm.trim().toLowerCase();
    let anyMatchFound = false;

    blogItems.forEach(item => {
      const cards = item.querySelectorAll('[js-gearmetter-card]');
      let matchFoundInItem = false;

      cards.forEach(card => {
        const titleElement = card.querySelector('[js-gearmetter-ttile]');
        if (titleElement) {
          const titleText = titleElement.textContent.toLowerCase();

          if (titleText.includes(term) || term === "") {
            card.style.display = "";
            if (term !== "") matchFoundInItem = true;
          } else {
            card.style.display = "none";
          }
        }
      });

      if (!matchFoundInItem && term !== "") {
        item.style.display = "none";
      } else {
        item.style.display = "";
      }

      if (matchFoundInItem) anyMatchFound = true;
    });

    if (term !== "" && !anyMatchFound) {
      noResult.style.display = "block";
    } else {
      noResult.style.display = "none";
    }
  }

  forms.forEach(form => {
    const input = form.querySelector('.hb_gearmatters-banner__input');
    const clearBtn = form.querySelector('.hb_gearmatters__clear');

    if (!input || !clearBtn) return;

    input.addEventListener("input", function () {
      filterCards(this.value);

      if (this.value.trim() !== "") {
        clearBtn.style.display = "block";
      } else {
        clearBtn.style.display = "none";
      }
    });

    clearBtn.addEventListener("click", function () {
      input.value = "";
      clearBtn.style.display = "none";
      filterCards("");
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      filterCards(input.value);
    });
  });

});

(function () {
  function applyReadMore() {
    document.querySelectorAll(".product_review_main_new .jdgm-quest__body").forEach(el => {
      if (el.dataset.readmoreApplied) return;

      if (el.scrollHeight > el.clientHeight) {
        const btn = document.createElement("span");
        btn.className = "jdgm-read-more";
        btn.textContent = " Read more";

        btn.style.color = "#e81c1c";
        btn.style.cursor = "pointer";
        btn.style.fontWeight = "500";

        btn.addEventListener("click", function () {
          el.classList.toggle("expanded");
          btn.textContent = el.classList.contains("expanded")
            ? " Read less"
            : " Read more";
        });

        el.after(btn);
      }

      el.dataset.readmoreApplied = "true";
    });
  }

  // Run once
  applyReadMore();

  // Watch for Judge.me AJAX load
  const observer = new MutationObserver(applyReadMore);
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Repairs page as well globally script for video section video script
document.querySelectorAll('.video-section .video_inner').forEach(videoInner => {
  const video = videoInner.querySelector('video');
  const playBtn = videoInner.querySelector('.play_JS');
  playBtn.addEventListener('click', function () {
    document.querySelectorAll('video').forEach(v => {
      if (v !== video) {
        v.pause();
        v.muted = true;
        const otherPlayBtn = v.closest('.video_inner')?.querySelector('.play_JS');
        if (otherPlayBtn) otherPlayBtn.classList.remove('hidden');
      }
    });
    video.muted = false;
    video.play();
    playBtn.classList.add('hidden');
  });
  video.addEventListener('click', function () {
    if (!video.paused) {
      video.pause();
      playBtn.classList.remove('hidden');
      return;
    }
    document.querySelectorAll('video').forEach(v => {
      if (v !== video) {
        v.pause();
        v.muted = true;
        const otherPlayBtn = v.closest('.video_inner')?.querySelector('.play_JS');
        if (otherPlayBtn) otherPlayBtn.classList.remove('hidden');
      }
    });
    video.muted = false;
    video.play();
    playBtn.classList.add('hidden');
  });
});

// 
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.variant_option_new').forEach(wrapper => {
    const labels = Array.from(wrapper.querySelectorAll('label'));

    labels.sort((a, b) => {
      const aAvailable = a.querySelector('input').dataset.optionAvailable === 'true';
      const bAvailable = b.querySelector('input').dataset.optionAvailable === 'true';

      return bAvailable - aAvailable; // in-stock first
    });

    labels.forEach(label => wrapper.appendChild(label));
  });
});





document.addEventListener("DOMContentLoaded", function () {

  function selectFirstAvailableSize() {
    const sizeFieldset = document.querySelector("fieldset.variant-option.size");
    if (!sizeFieldset) return;

    const availableLabel = sizeFieldset.querySelector("label.proavailable");
    if (!availableLabel) return;

    const radioInput = availableLabel.querySelector('input[type="radio"]');
    if (!radioInput) return;

    if (!radioInput.checked) {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ✅ On Page Load
  selectFirstAvailableSize();

  // ✅ On Colour Change
  const colourRadios = document.querySelectorAll(
    'fieldset.variant-option.colour input[type="radio"]'
  );

  colourRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      setTimeout(function () {
        selectFirstAvailableSize();
      }, 2000); 
    });
  });

});


function initCustomScrollbar(container) {
  if (!container || container.classList.contains("scrollbar-initialized")) return;
  container.classList.add("scrollbar-initialized");

  const containerHeight = container.clientHeight;

  container.style.position = "relative";
  container.style.overflow = "hidden";

  const contentWrapper = document.createElement("div");
  contentWrapper.className = "custom-scroll-content";
  contentWrapper.style.height = containerHeight + "px";
  contentWrapper.style.overflowY = "scroll";
  contentWrapper.style.paddingRight = "8px";
  contentWrapper.style.boxSizing = "content-box";

  while (container.firstChild) {
    contentWrapper.appendChild(container.firstChild);
  }

  container.appendChild(contentWrapper);

  const track = document.createElement("div");
  track.className = "custom-scrollbar-track";

  const thumb = document.createElement("div");
  thumb.className = "custom-scrollbar-thumb";

  track.appendChild(thumb);
  container.appendChild(track);

  function updateThumb() {
    const ratio = contentWrapper.clientHeight / contentWrapper.scrollHeight;
    const thumbHeight = Math.max(ratio * container.clientHeight, 40);
    thumb.style.height = thumbHeight + "px";
  }

  function syncThumb() {
    const maxScroll = contentWrapper.scrollHeight - contentWrapper.clientHeight;
    const maxThumbTop = container.clientHeight - thumb.clientHeight;
    thumb.style.top = (contentWrapper.scrollTop / maxScroll) * maxThumbTop + "px";
  }

  contentWrapper.addEventListener("scroll", syncThumb);

  let isDragging = false;
  let startY = 0;
  let startTop = 0;

  thumb.addEventListener("mousedown", function (e) {
    isDragging = true;
    startY = e.clientY;
    startTop = thumb.offsetTop;
    document.body.style.userSelect = "none";
  });

  document.addEventListener("mousemove", function (e) {
    if (!isDragging) return;

    const delta = e.clientY - startY;
    const newTop = startTop + delta;
    const maxTop = container.clientHeight - thumb.clientHeight;
    const limitedTop = Math.max(0, Math.min(maxTop, newTop));

    thumb.style.top = limitedTop + "px";

    const scrollPercent = limitedTop / maxTop;
    contentWrapper.scrollTop =
      scrollPercent * (contentWrapper.scrollHeight - contentWrapper.clientHeight);
  });

  document.addEventListener("mouseup", function () {
    isDragging = false;
    document.body.style.userSelect = "";
  });

  updateThumb();
  syncThumb();

  window.addEventListener("resize", function () {
    contentWrapper.style.height = container.clientHeight + "px";
    updateThumb();
    syncThumb();
  });
}

const observer = new MutationObserver(() => {
  const container = document.querySelector(".product_recommendations_product_list_new_bg");
  if (container) {
    initCustomScrollbar(container);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
